import { render, staticRenderFns } from "./huangPuUniversityReport.vue?vue&type=template&id=6be6fcbe&scoped=true"
import script from "./huangPuUniversityReport.vue?vue&type=script&lang=js"
export * from "./huangPuUniversityReport.vue?vue&type=script&lang=js"
import style0 from "./huangPuUniversityReport.vue?vue&type=style&index=0&id=6be6fcbe&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be6fcbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6be6fcbe')) {
      api.createRecord('6be6fcbe', component.options)
    } else {
      api.reload('6be6fcbe', component.options)
    }
    module.hot.accept("./huangPuUniversityReport.vue?vue&type=template&id=6be6fcbe&scoped=true", function () {
      api.rerender('6be6fcbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/printReport/huangPuUniversityReport/huangPuUniversityReport.vue"
export default component.exports